// Préfixe d'AFFICHAGE « Devis - » sur le numéro de devis (COSMÉTIQUE).
// ⚠️ Jamais concaténé dans la valeur stockée : la référence en base reste NUE
// (ex. "12345") → intégrité des références, Zoho, recherche, dédup préservées.
// Scopé au métier `omv` (TEF/Climat inchangés).
import { getBusinessModel } from "./tenantProfile";

export const DEVIS_DISPLAY_PREFIX = "Devis - ";

// Le préfixe d'affichage ne s'applique qu'au métier `omv` (égalité, pas la famille installateur).
export function devisPrefixEnabled() {
  return getBusinessModel() === "omv";
}

// Retire un préfixe legacy « DEVIS » en tête (casse libre, avec/sans tiret, deux-points
// ou espaces, ou collé à un chiffre) — ex. "DEVIS 2026264", "devis-00045", "DEVIS2026".
// Ne matche PAS un vrai mot ("DEVISERIE") : "devis" doit être suivi d'un séparateur,
// d'un chiffre, ou de la fin.
const LEGACY_DEVIS_PREFIX_RE = /^devis(?=[\s:–—-]|\d|$)[\s:–—-]*/i;

// Numéro NU → chaîne affichée « Devis - 12345 ». Anti double-préfixe : strip un
// « DEVIS » legacy avant de poser le préfixe propre. N'altère PAS la valeur stockée.
export function withDevisPrefix(numero) {
  const raw = String(numero || "").trim();
  if (!raw) return "";
  const bare = raw.replace(LEGACY_DEVIS_PREFIX_RE, "").trim();
  return `${DEVIS_DISPLAY_PREFIX}${bare || raw}`;
}
